import { useEffect } from "react";
import Layout from "../../layouts/Layout";
import { COMMON_LAYOUT } from "../../utils/constants";
import styles from "./DataProcessors.module.scss";
import Title from "../../components/Title/Title";

const data = [
  {
    name: "UAB Omnisend",
    code: "302530363",
    address: "Verkių g. 25C-1, LT-08223, Vilnius",
    description: "Klientų sąrašų valdymas rinkodaros kampanijoms",
  },
  {
    name: "UAB Paysera LT",
    code: "300060819",
    address: "Pilaitės pr. 16, LT-04352, Vilnius",
    description: "Tapatybės patvirtinimas",
  },
  {
    name: "AB Swedbank",
    code: "112029651",
    address: "Konstitucijos pr. 20A, LT-09321, Vilnius",
    description: "Tapatybės patvirtinimas",
  },
  {
    name: "SK ID Solutions AS Lietuvos filialas",
    code: "304977982",
    address: "Konstitucijos pr. 21a, LT-08130, Vilnius",
    description: "Tapatybės patvirtinimas",
  },
  {
    name: "VĮ Registrų centras",
    code: "124110246",
    address: "Studentų g. 39, LT-08106, Vilnius",
    description: "Tapatybės patvirtinimas",
  },
  {
    name: "UAB Scorify",
    code: "302423183",
    address: "Konstitucijos pr. 12, LT-09308, Vilnius",
    description: "Užklausų agregavimas, gauti registrų duomenis apie asmenis",
  },
  {
    name: "UAB Interneto vizija",
    code: "126350731",
    address: "J. Kubiliaus g. 6, LT-08234, Vilnius",
    description: "El. laiškų siuntimas iš CRM'o, duomenų saugojimas",
  },
  {
    name: 'Mailchimp c/o The Rocket Science Group, LLC',
    code: "Tax ID: MOSS No. EU372008134",
    address: "405 N. Angier Ave. NE, Atlanta, GA 30308, USA",
    description: "El. laiškų siuntimas su Mailchimp šablonais",
  },
  {
    name: "UAB Libonet",
    code: "302989530",
    address: "Europos pr. 122, LT-46351, Kaunas",
    description: "SMS siuntimas iš CRM'o",
  },
  {
    name: "Amazon Web Services, Inc.",
    code: "2549000I2PRQGGIGCA75 (LEI No.)",
    address: "C/O CORPORATION SERVICE COMPANY, 251 LITTLE FALLS DRIVE, WILMINGTON, 19808, United States of America",
    description: "Laikinas klientų paraiškų atsarginių kopijų saugojimas gamybinės sistemos neveikimo metu",
  },
  {
    name: "Creditinfo Lietuva, UAB",
    code: "111689163",
    address: "Lvivo g. 21A, LT-09313, Vilnius",
    description: "Gauti registrų duomenis apie asmenis",
  },
  {
    name: "UAB Telekomunikaciniai projektai (Telpro)",
    code: "123813761",
    address: "Pranciškaus Smuglevičiaus g. 21, LT-08333, Vilnius",
    description: "VoIP skambučiai (saugojami pokalbių įrašai, vardas, pavardė, telefono numeris)",
  },
  {
    name: "Dokobit, UAB",
    code: "301549834",
    address: "Paupio g. 50-136, LT-11341, Vilnius",
    description: "Dokumentų pasirašymas",
  },
  {
    name: "UAB iDenfy",
    code: "304617621",
    address: "K. Baršausko g. 59, LT-51423, Kaunas",
    description: "Tapatybės patvirtinimas",
  },
];

export default function DataProcessors() {
  useEffect(() => {
    document.title = "Duomenų tvarkytojai | Confindo";
  }, []);

  return (
    <Layout layout={COMMON_LAYOUT}>
      <div className="container-local">
        <div className={styles.container}>
          <Title className={styles.title} tag="h1">
            Duomenų tvarkytojai
          </Title>
          <p>
            Šiame puslapyje pateikiamas aktualus UAB „Confindo" pasitelkiamų pagalbinių duomenų tvarkytojų sąrašas.
            Sąrašas yra nuolat atnaujinamas. Apie bet kokius šio sąrašo pasikeitimus Duomenų valdytojai informuojami
            el. paštu ne vėliau kaip per 3 (tris) darbo dienas nuo sąrašo atnaujinimo. Duomenų valdytojai turi teisę
            pateikti motyvuotą prieštaravimą dėl naujų pagalbinių duomenų tvarkytojų per sutartyje numatytą terminą.
          </p>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Nr.</th>
                  <th>Pavadinimas</th>
                  <th>Juridinio asmens kodas</th>
                  <th>Buveinės adresas</th>
                  <th>Duomenų tvarkymo aprašymas</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}.</td>
                    <td>{item.name}</td>
                    <td>{item.code}</td>
                    <td>{item.address}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}
